// Theme by default loads a jQuery as dependency of the main script.
// Let's include it using ES6 modules import.
import $ from 'jquery'


$(document).ready(function () {
  var accordion = function () {
    $(".front-faq__accordion-header").on("click", function () {
      var accordionBody = $(this).next(".front-faq__accordion-body");

      // Slide toggle the accordion body
      accordionBody.slideToggle();

      // Toggle the active class on the accordion header
      $(this).toggleClass("active");
    });
  };

  accordion();


  $('.ba-trigger--right').click(function () {
    $(this).addClass('active');
    $('.ba-trigger--left').removeClass('active');
    $('.img-after').addClass('active');
  });
  $('.ba-trigger--left').click(function () {
    $(this).addClass('active');
    $('.ba-trigger--right').removeClass('active');
    $('.img-after').removeClass('active');
  });
});




// button on form page
let submit = document.querySelector("input.wpcf7-submit");
if (submit) {
  const wrapper = document.createElement("button");
  wrapper.setAttribute("class", "btn__contact");
  const contactSubmit = document.querySelector("input.wpcf7-submit");
  contactSubmit.parentNode.insertBefore(wrapper, contactSubmit);
  wrapper.appendChild(contactSubmit);
}




const container = document.querySelector('.container-before');

let slider1 = document.querySelector('.slider');
if ((slider1)) {
  document.querySelector('.slider').addEventListener('input', (e) => {
    container.style.setProperty('--position', `${e.target.value}%`);
  })
}

const container2 = document.querySelector('.container-before2');
let slider2 = document.querySelector('.slider2');
if ((slider2)) {
  document.querySelector('.slider2').addEventListener('input', (e) => {
    container2.style.setProperty('--position', `${e.target.value}%`);
  })
}
const container3 = document.querySelector('.container-before3');
let slider3 = document.querySelector('.slider3');
if ((slider3)) {
  document.querySelector('.slider3').addEventListener('input', (e) => {
    container3.style.setProperty('--position', `${e.target.value}%`);
  })
}



// mobile menu
let trigger = document.getElementById('hamburger');
trigger.addEventListener('click', e => {
  let menu = document.getElementById('nav');
  let body = document.body;
  let main = document.getElementById('app');
  let header = document.getElementById('header');

  if (!trigger.classList.contains('active')) {
    trigger.classList.add('active');
    menu.classList.add('active');
    header.classList.add('active');
    main.classList.add('menu-visible')
    body.classList.add('menu-active');

  } else {
    trigger.classList.remove('active');
    menu.classList.remove('active');
    body.classList.remove('menu-active');
    main.classList.remove('menu-visible');
    header.classList.remove('active');
  }
});


// import Swiper JS
// import Swiper from 'swiper';

import Swiper, { Navigation } from 'swiper';

Swiper.use([Navigation]);


var swiper = new Swiper(".mySwiper", {
  slidesPerView: 1,
  spaceBetween: 10,
  // centeredSlides: true,
  // loop: true,
  autoplay: {
    delay: 0,
  },
  breakpoints: {
    "@0.00": {
      slidesPerView: 2,
      spaceBetween: 80,
    },
    "@0.75": {
      slidesPerView: 3,
      spaceBetween: 60,
    },
    "@1.00": {
      slidesPerView: 4,
      spaceBetween: 60,
    },
    "@1.50": {
      slidesPerView: 5,
      spaceBetween: 60,
    },
  },


  // If we need pagination
  pagination: {
    el: '.swiper-pagination',
  },

  // Navigation arrows
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },

});


var swiper2 = new Swiper(".partners", {
  slidesPerView: 1,
  spaceBetween: 10,
  centeredSlides: false,
  loop: true,
  autoplay: {
    delay: 0,
  },
  breakpoints: {
    "@0.00": {
      slidesPerView: 2,
      spaceBetween: 40,
    },
    "@0.75": {
      slidesPerView: 3,
      spaceBetween: 60,
    },
    "@1.00": {
      slidesPerView: 4,
      spaceBetween: 40,
    },
    "@1.50": {
      slidesPerView: 5,
      spaceBetween: 60,
    },
  },


  // If we need pagination
  pagination: {
    el: '.swiper-pagination',
  },

  // Navigation arrows
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },

});





// WEBPACK FOOTER //
// ./resources/assets/js/app.js